import { api } from './request'

export default {
  // 获取农场变更列表
  list: (params) => api.get('/admin/farm-changes', { params }),

  // 获取农场变更详情
  get: (id) => api.get(`/admin/farm-changes/${id}`),

  // 审核农场变更
  review: (id, data) => api.put(`/admin/farm-changes/${id}/review`, data)
}
